// extracted by mini-css-extract-plugin
export default {"startButton":"StartApplicationButton_startButton__sH1vm","startButton_disabled":"StartApplicationButton_startButton_disabled__DNVvY"};